module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/4@2x_ef6da29b6c0904eff420f69ce222467f.png";